import authService from '../../components/api-authorization/AuthorizeService';
import { DataTableConstant } from 'hub-dashboard-framework';

export const isWorkingFolder = (state, folderId) => {
    return state.hubWorkingFolder && state.hubWorkingFolder.id === folderId;
};

export const isElasticSearchActive = (state) => {
    return state.action === DataTableConstant.HUB_ACTION_STATE.ELASTIC_SEARCH;
};

export const isCurrentUser = (userId) => {
    const currentUser = authService.getCurrentHubUser();
    return userId === currentUser.id;
};

export const getFolderById = (state, folderId) => {
    return state.hubFolderTree.find(folder => folder.id === folderId);
};

export const createNotification = (message, folder) => {
    return {
        msg: message,
        folder: folder,
        timestamp: new Date().toISOString()
    };
};
